module.exports = __webpack_public_path__ + "media/img/flags/it-95b408f33af413cb17523e393521ee2a.svg";